import home from './home';
import login from "./login";
import signup from "./signup";

const pages = {
    name: 'pages',
    label: 'Pages',
    files: [
        home('en'),
        login,
        signup ],
}

export default pages
